module.exports = __webpack_public_path__ + "img/layers.7fc6265e.svg";